import styled from "styled-components";
import { device } from "../hooks/device";
import useScrollLockThree from "../hooks/useScrollLockThree";
import useModal from "../hooks/useModal";
import { useSetRecoilState } from "recoil";
import { userInfo } from "../atoms";
import { MobileModalBack, ModalHeaderD } from "../components/Style";
import patchApi from "../api/patchApi";
import getApi from "../api/getApi";
import useToast from "../hooks/useToast";
import { useTranslation } from "react-i18next";

const ConvertIndividual = ({ setConvertModal }) => {
  const { t } = useTranslation();
  const baseLang = "servicePlan.g1";
  const showToast = useToast();
  const setUserData = useSetRecoilState(userInfo);
  useModal(setConvertModal);
  useScrollLockThree();

  const converting = () => {
    patchApi
      .memberWithdrawal()
      .then(() => {
        getApi
          .getUserData()
          .then(({ data }) => {
            setUserData(data?.getHost);
            window.history.back();
          })
          .catch(() => {
            // window.history.back();
            showToast({ message: "회원정보를 불러오지 못했습니다." });
          });
      })
      .catch(() => {
        showToast({ message: "개인회원 전환에 실패했습니다." });
      });
  };

  return (
    <>
      <MobileModalBack />
      <StModal>
        <ModalHeaderD title={t(`${baseLang}.title`)} />
        <div className="titleInfo">{t(`${baseLang}.body`)}</div>
        <div className="middlePart">{t(`${baseLang}.notice`)} </div>
        <ul>
          <li>{t(`${baseLang}.list1`)}</li>
          <li>{t(`${baseLang}.list2`)}</li>
          <li>{t(`${baseLang}.list3`)}</li>
        </ul>
        <div className="confirmPart">
          <span
            className="cancelButton"
            onClick={() => {
              window.history.back();
            }}
          >
            {t(`${baseLang}.button1`)}
          </span>
          <div className="columnBar" />
          <span className="convertButton" onClick={converting}>
            {t(`${baseLang}.button2`)}
          </span>
        </div>
      </StModal>
    </>
  );
};

const StModal = styled.div`
  position: fixed;
  z-index: 70;
  background-color: white;
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  .titlePart {
    font-size: 20px;
    font-family: "bold";
    line-height: 30px;
  }
  .middlePart {
    font-size: 16px;
    font-family: "semiBold";
    line-height: 24px;
  }
  .confirmPart {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: "medium";
    line-height: 27px;
    color: #0072de;
    padding: 4.5px 0;
    span {
      font-size: 18px;
      font-family: "medium";
    }
    .columnBar {
      width: 1px;
      height: 16px;
      background-color: #e6e6e6;
      margin: 0 42.5px 0 57px;
    }
  }
  ul {
    padding-left: 20px;
    margin-top: 4px;
    line-height: 24px;
  }
  @media ${device.pc} {
    left: 50%;
    top: 50%;
    padding: 60px;
    box-sizing: border-box;
    width: 580px;
    transform: translate(-50%, -50%);
    .titleInfo {
      font-size: 18px;
      font-family: "medium";
      line-height: 27px;
      margin-top: 48px;
    }
    .middlePart {
      margin-top: 48px;
    }
    .confirmPart {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: center;
      gap: 21px;
      margin-top: 32px;
      .cancelButton {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 204px;
        height: 52px;
        background: #ffffff;
        border: 1px solid #000000;
        border-radius: 43px;
        color: black;
        cursor: pointer;
      }
      .columnBar {
        display: none;
      }
      .convertButton {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 204px;
        height: 52px;
        background: #20315b;
        border-radius: 43px;
        color: white;
        cursor: pointer;
      }
    }
  }
  @media ${device.tabMob} {
    padding: 24px 24px 24px;
    box-sizing: border-box;
    border-radius: 24px;
    bottom: 16px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 53;
    width: 344px;
    .titleInfo {
      font-size: 16px;
      font-family: "regular";
      line-height: 24px;
    }
    .middlePart {
      margin-top: 20px;
    }
    .confirmPart {
      margin: 0 auto;
    }
  }
`;

export default ConvertIndividual;
